import { cn } from '@/lib/cn';
import { getForm, levelOf } from '@/lib/cardForm';
import type { CRPlayerCard } from '@/types/qbot';
import { CardIcon } from './CardIcon';

interface CardStripProps {
  cards: CRPlayerCard[];
  /** Tailwind width class per icon — defaults to a compact 26px tile for rows. */
  size?: string;
  showLevels?: boolean;
  className?: string;
}

/** Horizontal strip of card icons (a partial mini-deck). Reuses CardIcon so
 *  evolution rings + level overlays match the full DeckGrid. */
export function CardStrip({ cards, size = 'w-[26px]', showLevels = false, className }: CardStripProps) {
  if (!cards.length) return null;
  return (
    <div className={cn('flex gap-1', className)}>
      {cards.map((c, i) => {
        const form = getForm(c);
        const iconUrl =
          form === 'hero' ? c.iconUrls?.heroMedium
          : form === 'evolution' ? c.iconUrls?.evolutionMedium
          : c.iconUrls?.medium;
        return (
          <CardIcon
            key={`${c.id}-${i}`}
            id={c.id}
            name={c.name}
            form={form}
            iconUrl={iconUrl}
            level={showLevels ? levelOf(c) : undefined}
            className={size}
          />
        );
      })}
    </div>
  );
}
